import Today from "@mui/icons-material/Today";
import { styled } from "@mui/material/styles";
import { get } from "lodash";
import BSInput from "../../../common/js/components/BSInput";
import { formatLocalDate } from "../utils/operations";

// Styled components for grid replacement
const StyledContainer = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    margin: "0 -12px",
});

const StyledColumn = styled("div")(({ width }) => ({
    width: width,
    padding: "0 12px",
    boxSizing: "border-box",
}));

const StyledRow = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    margin: "0 -8px",
    marginBottom: "16px",
    width: "100%",
});

const StyledCell = styled("div")(({ width }) => ({
    width: width,
    padding: "0 8px",
    boxSizing: "border-box",
}));

const ManagementFees = (props) => {
    const { data, disableInputs, errors, handleBlurValidate, handleInput, sideBySide } = props;

    return (
        <StyledContainer>
            <StyledColumn width={sideBySide ? "50%" : "100%"}>
                <StyledRow>
                    <StyledCell width="100%">
                        <BSInput
                            id="flatRateFee"
                            label="Fixed Fee"
                            value={get(data, "flatRateFee", null)}
                            error={get(errors, "flatRateFee", null)}
                            errorText={"Field must be a positive number"}
                            onChange={(e) => handleInput(e.target.id, e.target.value)}
                            disabled={disableInputs}
                            startAdornment="$"
                            onBlurValidate={(id, value) => handleBlurValidate(id, value)}
                        />
                    </StyledCell>
                </StyledRow>

                <StyledRow>
                    <StyledCell width="50%">
                        <BSInput
                            id="percentOfRevenue"
                            label="% of Revenue"
                            value={get(data, "percentOfRevenue", "")}
                            error={get(errors, "percentOfRevenue", null)}
                            errorText={"Field must be a number between 0 and 100"}
                            onChange={(e) => handleInput(e.target.id, e.target.value)}
                            disabled={disableInputs}
                            startAdornment="%"
                            onBlurValidate={(id, value) => handleBlurValidate(id, value)}
                        />
                    </StyledCell>
                    <StyledCell width="50%">
                        <BSInput
                            id="minimumAmount"
                            label="Minimum"
                            value={get(data, "minimumAmount", "")}
                            error={get(errors, "minimumAmount", null)}
                            errorText={"Field must be a positive number"}
                            onChange={(e) => handleInput(e.target.id, e.target.value)}
                            disabled={disableInputs}
                            startAdornment="$"
                            onBlurValidate={(id, value) => handleBlurValidate(id, value)}
                        />
                    </StyledCell>
                </StyledRow>
                <StyledRow>
                    <StyledCell width="100%">
                        <BSInput
                            id="effectiveMonthIncrease"
                            label="Effective Month Increase"
                            placeholder="Enter effective month increase"
                            value={get(data, "effectiveMonthIncrease", "")}
                            error={get(errors, "effectiveMonthIncrease", null)}
                            errorText={"Field must be a number between 1 and 12"}
                            onChange={(e) => handleInput(e.target.id, e.target.value)}
                            disabled={disableInputs}
                            onBlurValidate={(id, value) => handleBlurValidate(id, value)}
                        />
                    </StyledCell>
                </StyledRow>
            </StyledColumn>

            {/* right column */}
            <StyledColumn width={sideBySide ? "50%" : "100%"}>
                <StyledRow>
                    <StyledCell width="100%">
                        <BSInput
                            id="cpi"
                            label="CPI"
                            placeholder="Enter CPI"
                            value={get(data, "cpi", "")}
                            error={get(errors, "cpi", null)}
                            onChange={(e) => handleInput(e.target.id, e.target.value)}
                            disabled={disableInputs}
                        />
                    </StyledCell>
                </StyledRow>

                <StyledRow>
                    <StyledCell width="33.33%">
                        <BSInput
                            id="minMgtFee"
                            label="MINIMUM (%)"
                            placeholder="Enter minimum"
                            value={get(data, "minMgtFee", "")}
                            error={get(errors, "minMgtFee", null)}
                            errorText={"Field must be a number between 0 and 100"}
                            onChange={(e) => handleInput(e.target.id, e.target.value)}
                            disabled={disableInputs}
                            startAdornment="%"
                            onBlurValidate={(id, value) => handleBlurValidate(id, value)}
                        />
                    </StyledCell>
                    <StyledCell width="33.33%">
                        <BSInput
                            id="maxMgtFee"
                            label="MAXIMUM (%)"
                            placeholder="Enter maximum"
                            value={get(data, "maxMgtFee", "")}
                            error={get(errors, "maxMgtFee", null)}
                            errorText={"Field must be a number between 0 and 100"}
                            onChange={(e) => handleInput(e.target.id, e.target.value)}
                            disabled={disableInputs}
                            startAdornment="%"
                            onBlurValidate={(id, value) => handleBlurValidate(id, value)}
                        />
                    </StyledCell>
                    <StyledCell width="33.33%">
                        <BSInput
                            id="dateOfIncrease"
                            label="Date Of Increase"
                            placeholder="Enter date of increase"
                            value={get(data, "dateOfIncrease", "")}
                            error={get(errors, "dateOfIncrease", null)}
                            onChange={(e) => handleInput(e.target.id, formatLocalDate(e.target.value))}
                            disabled={disableInputs}
                            startAdornment={<Today />}
                            type="date"
                        />
                    </StyledCell>
                </StyledRow>
                <StyledRow>
                    <StyledCell width="100%">
                        <BSInput
                            id="salaryReimbursementsComment"
                            label="Salary Reimbursement"
                            placeholder="Enter salary reimbursement data/comments"
                            value={get(data, "salaryReimbursementsComment", "")}
                            error={get(errors, "salaryReimbursementsComment", null)}
                            onChange={(e) => handleInput(e.target.id, e.target.value)}
                            disabled={!get(data, "salaryReimbursementsFlg", false) || disableInputs}
                            checkbox={true}
                            checkboxVal={"salaryReimbursementsFlg"}
                            disableCheckbox={disableInputs}
                            onChangeCheckbox={() =>
                                handleInput("salaryReimbursementsFlg", !get(data, "salaryReimbursementsFlg", false))
                            }
                            checked={get(data, "salaryReimbursementsFlg", false)}
                        />
                    </StyledCell>
                </StyledRow>
            </StyledColumn>
        </StyledContainer>
    );
};

export default ManagementFees;
